<template>
<sdPageHeader :title="$t('pages.categories.title')" />
  <Main>
    <sdCards>
      <a-row :gutter="16">
        <a-col :span="4">
          <label> {{ $t('pages.categories.label-state') }} </label>
          <a-select
            :placeholder="$t('common.choose')"
            style="width: 100%"
            v-model:value="filter.active"
            @change="onFilterChange"
          >
            <a-select-option :value="null">
              {{ $t('common.choose') }}
            </a-select-option>
            <a-select-option :value="1">
              {{ $t('common.1') }}
            </a-select-option>
            <a-select-option :value="0">
              {{ $t('common.0') }}
            </a-select-option>
          </a-select>
        </a-col>

        <a-col :span="4">
          <label> &nbsp;</label>
          <SearchBoxVue v-model:text="filter.search" @text-changed="onFilterChange()" />
        </a-col>

        <a-col :span="4">
          <label> &nbsp;</label>
          <sdButton size="default" :outlined="true" type="success" style="width: 100%" @click="onClickFilter">
            {{ $t('common.filter') }}
          </sdButton>
        </a-col>

        <a-col :span="4">
          <label> &nbsp;</label>
          <sdButton
            size="default"
            :outlined="true"
            type="primary"
            style="width: 100%"
            @click="modalCreate = !modalCreate"
          >
            {{ $t('pages.categories.create-category') }}
          </sdButton>
        </a-col>
      </a-row>
      <br />

      <div v-if="isLoading" class="spin">
        <a-spin />
      </div>
      <div v-else>
        <a-table
          class="table-responsive"
          :columns="columns"
          :data-source="tableData"
          :pagination="{
            pageSize: this.filter.pageSize,
            showSizeChanger: true,
            total: this.filter.total,
            current: this.filter.current,
          }"
          @change="onTableChange"
          size="small"
        >

        <template #common_title="{ record }">
            <span> {{ this.$store.state.i18n.i_lang == 'en' ? record.title_en : record.title }} </span>
          </template>

          <template #description="{ record }">
            <span> {{ this.$store.state.i18n.i_lang == 'en' ? record.description_en : record.description }} </span>
          </template>


          <template #active="{ record }">
            <a-space align="baseline">
              <a-switch v-model:checked="record.active" @click="onToggleChange(record)" />
              <p>{{ record.active ? $t('common.1') : $t('common.0') }}</p>
            </a-space>
          </template>

          <template #action="{ record }">
            <a-space>
              <a-tooltip placement="top">
                <template #title>
                  <span>{{ $t('common.remove') }}</span>
                </template>
                <a-button type="primary" @click="deleteRecord(record.key)">
                  <template #icon> <sdFeatherIcons type="trash-2" style="color: white" /> </template>
                </a-button>
              </a-tooltip>
              <a-tooltip placement="top">
                <template #title>
                  <span>{{ $t('common.edit') }}</span>
                </template>
                <a-button type="primary" @click="editCategory(record)">
                  <template #icon> <sdFeatherIcons type="edit" style="color: white" /> </template>
                </a-button>
              </a-tooltip>
            </a-space>
          </template>
        </a-table>
      </div>
    </sdCards>
  </Main>

  <a-modal v-model:visible="modalCreate" :title="$t('pages.categories.modal-create.title')" @ok="createModalOnOk">
    <template #footer>
      <a-button @click="createModalOnCancel">{{ $t('common.cancel') }}</a-button>
      <a-button type="primary" @click="createModalOnOk">{{ $t('common.save') }}</a-button>
    </template>
    <div>
      <a-form layout="vertical" :model="form" @submit="createModalOnOk">
        <a-form-item :label="$t('pages.categories.modal-create.label-title-tr')">
          <a-input v-model:value="form.title" auto-size required/>
        </a-form-item>
        <a-form-item :label="$t('pages.categories.modal-create.label-description-tr')">
          <a-textarea v-model:value="form.description" :auto-size="{ minRows: 2, maxRows: 5 }" required/>
        </a-form-item>
        <a-form-item :label="$t('pages.categories.modal-create.label-title-en')">
          <a-input v-model:value="form.title_en" auto-size required/>
        </a-form-item>
        <a-form-item :label="$t('pages.categories.modal-create.label-description-en')">
          <a-textarea v-model:value="form.description_en" :auto-size="{ minRows: 2, maxRows: 5 }" required/>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>

  <a-modal v-model:visible="modalDetail" :title="$t('pages.categories.modal-detail.title')" @ok="detailModalOnOk">
    <template #footer>
      <a-button @click="detailModalOnCancel">{{ $t('common.cancel') }}</a-button>
      <a-button type="primary" @click="detailModalOnOk">{{ $t('common.save') }}</a-button>
    </template>
    <div>
      <a-form layout="vertical" :model="updateForm" @submit="detailModalOnOk">
        <a-form-item :label="$t('pages.categories.modal-detail.label-title-tr')">
          <a-textarea v-model:value="updateForm.title" required  auto-size  />
        </a-form-item>
        <a-form-item :label="$t('pages.categories.modal-detail.label-description-tr')">
          <a-textarea v-model:value="updateForm.description" required :auto-size="{ minRows: 2, maxRows: 5 }"  />
        </a-form-item>
        <a-form-item :label="$t('pages.categories.modal-detail.label-title-en')">
          <a-textarea v-model:value="updateForm.title_en" required auto-size />
        </a-form-item>
        <a-form-item :label="$t('pages.categories.modal-detail.label-description-en')">
          <a-textarea v-model:value="updateForm.description_en" required :auto-size="{ minRows: 2, maxRows: 5 }" />
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
import { Main } from '@/view/styled';
import SearchBoxVue from '@/components/search/SearchBox.vue';

export default {
  name: 'ApplicationCategories',
  components: {
    Main,
    SearchBoxVue,
  },
  data() {
    return {
      isLoading: true,
      isFilterNew: false,
      modalDetail: false,
      modalCreate: false,
      form: {},
      updateForm: {},
      filter: {
        current: 1,
        pageSize: 10,
        total: null,
        active: null,
        search: '',
      },
      tableData: [],
      columns: [
        {
          title: this.$t('pages.categories.table.title'),
          dataIndex: 'title',
          key: 'title',
          slots: { customRender: 'common_title' },
        },
        {
          title: this.$t('pages.categories.table.description'),
          dataIndex: 'description',
          key: 'description',
          slots: { customRender: 'description' },
        },
        {
          title: this.$t('pages.categories.table.state'),
          dataIndex: 'active',
          key: 'active',
          slots: { customRender: 'active' },
        },
        {
          title: this.$t('pages.categories.table.action'),
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    editCategory(item) {
        this.updateForm.id = item.key;
        this.updateForm.title = item.title;
        this.updateForm.title_en = item.title_en;
        this.updateForm.description = item.description;
        this.updateForm.description_en = item.description_en;
        this.modalDetail = true;
    },
    getTableData() {
      this.isLoading = true;
      this.isFilterNew = false;

      this.$appAxios
        .post(this.$endpoints.categories_get_table, this.filter)
        .then(response => {
          if (response.data.status) {
            var tableRecords = response.data.data.tableData;
            console.log(tableRecords);
            this.filter.total = response.data.data.total;
            this.tableData = [];
            var _this = this;
            tableRecords.forEach(function(item, index) {
              _this.tableData.push({
                key: item.id,
                title: item.title,
                title_en: item.title_en,
                description: item.description,
                description_en: item.description_en,
                active: item.active ? true : false,
              });
            });
          } else {
            this.$message.error(this.$t('common.error-message'));
          }
          this.isLoading = false;
        })
        .catch(e => {
          this.$message.error(this.$t('common.error-message'));
        });
    },
    onClickFilter() {
      this.isFilterNew = true;
      this.filter.current = 1;
      this.getTableData();
    },
    onTableChange(e) {
      this.filter.current = this.isFilterNew ? 1 : e.current;
      this.filter.pageSize = e.pageSize;
      this.getTableData();
    },
    onFilterChange(e) {
      this.isFilterNew = true;
    },
    onToggleChange(record) {
      this.updateCategoryStatus(record.key, record.active);
    },
    updateCategoryStatus(id, active) {
      var request = { id: id, active: active };
      this.$appAxios
        .post(this.$endpoints.categories_change_status, request)
        .then(response => {
          if (response.data.status === true) {
            this.$message.success(this.$t('common.success-message'));
          } else {
            this.$message.error(this.$t('common.error-message'));
          }
        })
        .catch(e => {
          this.$message.error(this.$t('common.error-message'));
        });
    },
    deleteRecord(id) {
      if (!confirm(this.$t('common.confirm-delete'))) {
        return;
      }

      var request = {
        id: id,
      };

      this.$appAxios
        .post(this.$endpoints.categories_delete, request)
        .then(response => {
          if (response.data.status === true) {
            this.getTableData();
            this.$message.success(this.$t('common.success-message'));
          } else {
            this.$message.error(this.$t('common.error-message'));
          }
        })
        .catch(e => {
          this.$message.error(this.$t('common.error-message'));
        });
    },
    createModalOnCancel() {
      this.modalCreate = false;
    },
    createModalOnOk() {
      this.createCategory();
    },
    detailModalOnCancel() {
      this.modalDetail = false;
    },
    detailModalOnOk() {
      this.updateCategory();
    },
    createCategory() {
      this.$appAxios
        .post(this.$endpoints.categories_create, this.form)
        .then(response => {
          if (response.data.status === true) {
            this.$message.success(this.$t('common.success-message'));
            this.modalCreate = false;
            this.form = {};
            this.getTableData();
          } else {
            this.$message.error(response.data.message || this.$t('common.error-message'));
          }
        })
        .catch(e => {
          this.$message.error(this.$t('common.error-message'));
        });
    },
    updateCategory() {
      this.$appAxios
        .post(this.$endpoints.categories_update, this.updateForm)
        .then(response => {
          if (response.data.status === true) {
            this.$message.success(this.$t('common.success-message'));
            this.updateForm = {};
            this.modalDetail = false;
            this.getTableData();
          } else {
            this.$message.error(response.data.message || this.$t('common.error-message'));
          }
        })
        .catch(e => {
          this.$message.error(this.$t('common.error-message'));
        });
    },
  },
};
</script>
